// extracted by mini-css-extract-plugin
export default {"workspace":"workspace___Jsh0n"};